module.exports = __webpack_public_path__ + "img/solut.06d6f130.png";